// extracted by mini-css-extract-plugin
export default {"wrapper":"kC-z","button":"lC-z","alternate":"mC-z","disabled":"nC-z","paymentWarning":"oC-z","fadeIn":"pC-z"};